import { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  tr: {
    nav: {
      about: "Kurumsal",
      services: "Faaliyetlerimiz",
      sustainability: "Sürdürülebilirlik",
      contact: "İletişim",
      quote: "Teklif Al",
    },
    hero: {
      badge: "Küresel Tarım İhracat Ağı",
      titleLine1: "Tarladan Dünyaya,",
      titleLine2: "Küresel Tarım Gücü.",
      sub: "Markagro Global; yüksek teknolojili üretim tesisleri, kesintisiz soğuk zincir lojistiği ve 40'tan fazla ülkeye uzanan ihracat ağıyla Anadolu'nun tarımsal zenginliğini dünya sofralarına taşır.",
      ctaPrimary: "Faaliyetlerimizi İnceleyin",
      ctaSecondary: "Bize Ulaşın",
      routesLabel: "Aktif Sevkiyat Rotaları",
      routes: ["Mersin → Rotterdam", "Antalya → Dubai", "İzmir → Hamburg", "Adana → Riyad", "Bursa → Londra"],
      scroll: "Keşfetmek için kaydırın",
    },
    marquee: [
      "GlobalGAP Sertifikalı Üretim",
      "Kesintisiz Soğuk Zincir",
      "%100 Sürdürülebilir Tarım",
      "40+ Ülkeye İhracat",
      "Tam İzlenebilirlik",
    ],
    about: {
      overline: "Kurumsal",
      title: "Toprağın gücünü küresel ticarete dönüştürüyoruz.",
      intro:
        "Markagro Global; Türkiye merkezli, üretimden limana uzanan uçtan uca ihracat modeliyle faaliyet gösteren uluslararası bir tarım şirketidir. Sözleşmeli üretici ağımız, modern sera yatırımlarımız ve kendi lojistik planlamamızla taze ürünü; doğru zamanda, doğru pazara, belgelenmiş kaliteyle ulaştırırız.",
      chapters: [
        {
          num: "01",
          title: "Vizyon & Küresel Konumlanma",
          text: "Tarımı yalnızca bir üretim faaliyeti değil, küresel ölçekte yönetilen bir değer zinciri olarak görüyoruz. Akdeniz'in verimli havzalarından yola çıkarak Avrupa, Körfez ve Uzak Doğu pazarlarında güvenilir bir tedarik ortağı olarak konumlanıyoruz.",
        },
        {
          num: "02",
          title: "İhracat Güvenilirliği",
          text: "Her sevkiyat; planlanmış hasat takvimi, sözleşmeli üretici disiplini ve uçtan uca izlenebilir lojistik ile güvence altındadır. Bizim için zamanında teslimat bir hedef değil, yazılı bir standarttır.",
        },
        {
          num: "03",
          title: "Tavizsiz Kalite Politikası",
          text: "Tarladan konteynere kadar her parti ürün; GlobalGAP, ISO 22000 ve BRCGS gerekliliklerine göre denetlenir, akredite laboratuvar analizleriyle belgelenir. Kalite bizde bir slogan değil, ölçülen bir süreçtir.",
        },
      ],
      captionA: "Yüksek Teknolojili Sera Üretimi — Antalya",
      captionB: "Konteyner Terminali — Mersin",
    },
    services: {
      overline: "Faaliyetlerimiz",
      title: "Sahadan limana eksiksiz ihracat mimarisi",
      sub: "Dört ana iş kolumuz, tarımsal üretimin her aşamasını tek çatı altında birleştirir.",
      items: [
        {
          tag: "Global Export",
          title: "Uluslararası Tarım İhracatı",
          desc: "Narenciyeden taze sebze ve meyveye, tahıldan bakliyata; 40'tan fazla ülkeye sözleşmeli, düzenli ve tam izlenebilir ihracat operasyonları yürütüyoruz.",
        },
        {
          tag: "Precision Farming",
          title: "Modern Tarım Uygulamaları ve Üretim",
          desc: "Yüksek teknolojili cam seralar, hassas tarım sensörleri ve telemetri destekli sulama ile verimi artırıyor; her dönümden ihracat kalitesinde ürün elde ediyoruz.",
        },
        {
          tag: "Cold Chain",
          title: "Tedarik Zinciri ve Lojistik Yönetimi",
          desc: "Hasat anından varış limanına kadar kesintisiz soğuk zincir; deniz, kara ve hava yolunu birleştiren çok modlu taşımacılık çözümleri sunuyoruz.",
        },
        {
          tag: "GlobalGAP · ISO 22000",
          title: "Kalite Kontrol ve Sertifikasyon",
          desc: "Akredite laboratuvar analizleri, kalıntı testleri ve uluslararası denetim süreçleriyle her sevkiyatın hedef pazar standartlarına tam uyumunu belgeliyoruz.",
        },
      ],
    },
    stats: {
      overline: "Neden Markagro?",
      title: "Rakamlarla küresel güven",
      sub: "İhracat performansımız; her yıl büyüyen üretim kapasitemiz ve bağımsız denetimden geçen süreçlerimizle konuşur.",
      items: [
        { value: 40, pre: { tr: "", en: "" }, suf: { tr: "+", en: "+" }, label: "İhracat Ülkesi", desc: "Avrupa, Körfez, Asya ve Afrika'da aktif dağıtım ağı" },
        { value: 10000, pre: { tr: "", en: "" }, suf: { tr: "+", en: "+" }, label: "Ton Yıllık Hacim", desc: "Sözleşmeli üretimle güvence altına alınmış yıllık kapasite" },
        { value: 100, pre: { tr: "%", en: "" }, suf: { tr: "", en: "%" }, label: "Sürdürülebilir Üretim", desc: "İzlenebilir, sertifikalı ve çevre dostu üretim standardı" },
        { value: 24, pre: { tr: "", en: "" }, suf: { tr: "/7", en: "/7" }, label: "Soğuk Zincir İzleme", desc: "Telemetri destekli kesintisiz sıcaklık ve konum takibi" },
      ],
    },
    sustainability: {
      overline: "Sürdürülebilirlik",
      title: "Doğayla birlikte büyüyoruz.",
      text: "Karbon ayak izimizi azaltmak için yenilenebilir enerjiyle çalışan seralar, %60'a varan su tasarrufu sağlayan damla sulama telemetrisi ve geri dönüştürülebilir ambalaj kullanıyoruz. 2030 hedefimiz net ve ölçülebilir: sıfır atıklı bir tedarik zinciri.",
      goal: "2030 Taahhüdü",
      goalText: "Net sıfır atıklı tedarik zinciri ve %100 yenilenebilir enerjiyle çalışan üretim tesisleri.",
      badges: ["Yenilenebilir Enerji", "%60 Su Tasarrufu", "Geri Dönüştürülebilir Ambalaj", "Biyo-Gübre Kullanımı"],
    },
    contact: {
      overline: "İletişim",
      title: "Bir sonraki sevkiyatınızı birlikte planlayalım.",
      sub: "İhracat talepleriniz için formu doldurun; ticari ekibimiz 24 saat içinde size geri dönsün.",
      form: {
        name: "Ad Soyad",
        email: "Kurumsal E-posta",
        country: "Ülke / Şehir",
        service: "İlgilendiğiniz Ürün / Hizmet",
        message: "Mesajınız",
        submit: "Talebi Gönder",
      },
      info: {
        hqTitle: "Küresel Merkez",
        hq: "Mersin Serbest Bölge, Akdeniz İhracat Koridoru, 33110 Mersin / Türkiye",
        officeTitle: "Üretim & İrtibat Ofisi",
        office: "Antalya Organize Tarım Bölgesi, Antalya / Türkiye",
        phoneTitle: "Telefon",
        phone: "+90 242 502 40 40",
        emailTitle: "E-posta",
        email: "info@markagroglobal.com",
      },
      newsletter: {
        title: "Hasat Bülteni",
        sub: "Sezonluk ürün takvimi ve ihracat fırsatları e-postanıza gelsin.",
        placeholder: "E-posta adresiniz",
        button: "Abone Ol",
      },
      footerTagline: "Tarladan dünyaya, belgelenmiş kalite.",
      footerCols: [
        { title: "Kurumsal", links: ["Hakkımızda", "Kalite Politikamız", "Sertifikalar", "Kariyer"] },
        { title: "Faaliyetler", links: ["Tarım İhracatı", "Modern Üretim", "Lojistik", "Sertifikasyon"] },
        { title: "Yasal", links: ["KVKK Aydınlatma Metni", "Çerez Politikası", "Kullanım Koşulları"] },
      ],
      certs: "GLOBALG.A.P. · ISO 22000 · BRCGS · SEDEX",
      rights: "© 2026 Markagro Global. Tüm hakları saklıdır.",
    },
    quote: {
      title: "Teklif Al",
      sub: "İhtiyacınızı paylaşın, size özel ihracat teklifinizi hazırlayalım.",
      name: "Ad Soyad",
      email: "Kurumsal E-posta",
      product: "Ürün Grubu",
      products: ["Narenciye", "Taze Sebze & Meyve", "Tahıl & Bakliyat", "Sera Ürünleri"],
      volume: "Tahmini Hacim",
      unit: "ton",
      submit: "Teklif Talebi Gönder",
    },
    toasts: {
      contact: "Talebiniz alındı — ticari ekibimiz en kısa sürede sizinle iletişime geçecek.",
      newsletter: "Hasat Bülteni'ne abone oldunuz — hoş geldiniz.",
      quote: "Teklif talebiniz alındı — 24 saat içinde dönüş yapacağız.",
      error: "Bir sorun oluştu — lütfen daha sonra tekrar deneyin.",
    },
  },
  en: {
    nav: {
      about: "Corporate",
      services: "Operations",
      sustainability: "Sustainability",
      contact: "Contact",
      quote: "Get a Quote",
    },
    hero: {
      badge: "Global Agri-Export Network",
      titleLine1: "From Field to Globe,",
      titleLine2: "World-Class Agri Power.",
      sub: "Markagro Global carries Anatolia's agricultural wealth to tables worldwide — through high-tech production facilities, unbroken cold-chain logistics and an export network spanning more than 40 countries.",
      ctaPrimary: "Explore Our Operations",
      ctaSecondary: "Contact Us",
      routesLabel: "Active Shipment Routes",
      routes: ["Mersin → Rotterdam", "Antalya → Dubai", "Izmir → Hamburg", "Adana → Riyadh", "Bursa → London"],
      scroll: "Scroll to explore",
    },
    marquee: [
      "GlobalGAP Certified Production",
      "Unbroken Cold Chain",
      "100% Sustainable Agriculture",
      "Exporting to 40+ Nations",
      "Full Traceability",
    ],
    about: {
      overline: "Corporate",
      title: "We turn the power of soil into global trade.",
      intro:
        "Markagro Global is a Türkiye-based international agriculture company operating an end-to-end export model from production to port. With our contracted grower network, modern greenhouse investments and in-house logistics planning, we deliver fresh produce to the right market, at the right time, with documented quality.",
      chapters: [
        {
          num: "01",
          title: "Vision & Global Positioning",
          text: "We see agriculture not merely as production, but as a globally managed value chain. From the fertile basins of the Mediterranean, we position ourselves as a trusted supply partner across Europe, the Gulf and Far East markets.",
        },
        {
          num: "02",
          title: "Export Reliability",
          text: "Every shipment is secured by a planned harvest calendar, disciplined contracted growers and end-to-end traceable logistics. For us, on-time delivery is not a goal — it is a written standard.",
        },
        {
          num: "03",
          title: "Uncompromising Quality Policy",
          text: "From field to container, every lot is audited against GlobalGAP, ISO 22000 and BRCGS requirements and documented by accredited laboratory analyses. Quality is not a slogan; it is a measured process.",
        },
      ],
      captionA: "High-Tech Greenhouse Production — Antalya",
      captionB: "Container Terminal — Mersin",
    },
    services: {
      overline: "Our Operations",
      title: "A complete export architecture, from field to port",
      sub: "Our four core business lines unite every stage of agricultural production under one roof.",
      items: [
        {
          tag: "Global Export",
          title: "International Agricultural Export",
          desc: "From citrus to fresh fruit and vegetables, grains to pulses — we run contracted, regular and fully traceable export operations to more than 40 countries.",
        },
        {
          tag: "Precision Farming",
          title: "Precision Farming & Production",
          desc: "High-tech glass greenhouses, precision agriculture sensors and telemetry-assisted irrigation raise yields — delivering export-grade produce from every hectare.",
        },
        {
          tag: "Cold Chain",
          title: "Supply Chain & Logistics Management",
          desc: "An unbroken cold chain from the moment of harvest to the port of destination, with multimodal transport solutions combining sea, land and air.",
        },
        {
          tag: "GlobalGAP · ISO 22000",
          title: "Quality Control & Certification",
          desc: "Accredited laboratory analyses, residue testing and international audit processes certify every shipment's full compliance with target-market standards.",
        },
      ],
    },
    stats: {
      overline: "Why Markagro?",
      title: "Global trust, in numbers",
      sub: "Our export performance speaks through capacity that grows every year and processes that are independently audited.",
      items: [
        { value: 40, pre: { tr: "", en: "" }, suf: { tr: "+", en: "+" }, label: "Export Destinations", desc: "Active distribution across Europe, the Gulf, Asia and Africa" },
        { value: 10000, pre: { tr: "", en: "" }, suf: { tr: "+", en: "+" }, label: "Tonnes Annual Volume", desc: "Annual export capacity secured by contracted production" },
        { value: 100, pre: { tr: "%", en: "" }, suf: { tr: "", en: "%" }, label: "Sustainable Production", desc: "Traceable, certified and eco-friendly production standard" },
        { value: 24, pre: { tr: "", en: "" }, suf: { tr: "/7", en: "/7" }, label: "Cold-Chain Monitoring", desc: "Telemetry-backed, uninterrupted temperature and location tracking" },
      ],
    },
    sustainability: {
      overline: "Sustainability",
      title: "We grow together with nature.",
      text: "To cut our carbon footprint we operate renewable-powered greenhouses, drip-irrigation telemetry saving up to 60% water, and recyclable packaging. Our 2030 goal is clear and measurable: a zero-waste supply chain.",
      goal: "2030 Commitment",
      goalText: "A net zero-waste supply chain and production facilities running on 100% renewable energy.",
      badges: ["Renewable Energy", "60% Water Savings", "Recyclable Packaging", "Bio-Fertilizer Use"],
    },
    contact: {
      overline: "Contact",
      title: "Let's plan your next shipment together.",
      sub: "Fill in the form for your export enquiries; our trade team will get back to you within 24 hours.",
      form: {
        name: "Full Name",
        email: "Corporate Email",
        country: "Country / City",
        service: "Product / Service of Interest",
        message: "Your Message",
        submit: "Send Request",
      },
      info: {
        hqTitle: "Global Headquarters",
        hq: "Mersin Free Zone, Mediterranean Export Corridor, 33110 Mersin / Türkiye",
        officeTitle: "Production & Liaison Office",
        office: "Antalya Organized Agriculture Zone, Antalya / Türkiye",
        phoneTitle: "Phone",
        phone: "+90 242 502 40 40",
        emailTitle: "Email",
        email: "info@markagroglobal.com",
      },
      newsletter: {
        title: "Harvest Bulletin",
        sub: "Seasonal crop calendars and export opportunities, delivered to your inbox.",
        placeholder: "Your email address",
        button: "Subscribe",
      },
      footerTagline: "From field to globe, with certified quality.",
      footerCols: [
        { title: "Corporate", links: ["About Us", "Quality Policy", "Certifications", "Careers"] },
        { title: "Operations", links: ["Agri Export", "Modern Production", "Logistics", "Certification"] },
        { title: "Legal", links: ["Privacy Notice", "Cookie Policy", "Terms of Use"] },
      ],
      certs: "GLOBALG.A.P. · ISO 22000 · BRCGS · SEDEX",
      rights: "© 2026 Markagro Global. All rights reserved.",
    },
    quote: {
      title: "Get a Quote",
      sub: "Tell us what you need and we will prepare a tailored export offer.",
      name: "Full Name",
      email: "Corporate Email",
      product: "Product Group",
      products: ["Citrus", "Fresh Fruit & Vegetables", "Grains & Pulses", "Greenhouse Produce"],
      volume: "Estimated Volume",
      unit: "t",
      submit: "Send Quote Request",
    },
    toasts: {
      contact: "Your request has been received — our trade team will contact you shortly.",
      newsletter: "You've subscribed to the Harvest Bulletin — welcome aboard.",
      quote: "Your quote request has been received — we'll reply within 24 hours.",
      error: "Something went wrong — please try again later.",
    },
  },
  ru: {
    nav: {
      about: "Компания",
      services: "Деятельность",
      sustainability: "Устойчивое развитие",
      contact: "Контакты",
      quote: "Запросить цену",
    },
    hero: {
      badge: "Глобальная экспортная сеть",
      titleLine1: "С поля — в мир,",
      titleLine2: "Глобальная сила агросектора.",
      sub: "Markagro Global доставляет сельскохозяйственное богатство Анатолии на столы всего мира — через высокотехнологичные производственные мощности, непрерывную холодовую цепь и экспортную сеть, охватывающую более 40 стран.",
      ctaPrimary: "Наша деятельность",
      ctaSecondary: "Связаться с нами",
      routesLabel: "Активные маршруты поставок",
      routes: ["Мерсин → Роттердам", "Анталья → Дубай", "Измир → Гамбург", "Адана → Эр-Рияд", "Бурса → Лондон"],
      scroll: "Прокрутите, чтобы узнать больше",
    },
    marquee: [
      "Сертифицированное производство GlobalGAP",
      "Непрерывная холодовая цепь",
      "100% устойчивое земледелие",
      "Экспорт в более чем 40 стран",
      "Полная прослеживаемость",
    ],
    about: {
      overline: "Компания",
      title: "Мы превращаем силу земли в глобальную торговлю.",
      intro:
        "Markagro Global — международная агрокомпания с центральным офисом в Турции, работающая по сквозной экспортной модели: от производства до порта. Благодаря сети контрактных производителей, современным теплицам и собственной логистике мы доставляем свежую продукцию на нужный рынок, в нужное время и с подтверждённым качеством.",
      chapters: [
        {
          num: "01",
          title: "Видение и глобальное позиционирование",
          text: "Мы рассматриваем сельское хозяйство не просто как производство, а как цепочку создания стоимости мирового масштаба. Отправляясь от плодородных регионов Средиземноморья, мы позиционируем себя как надёжного партнёра по поставкам на рынках Европы, Персидского залива и Дальнего Востока.",
        },
        {
          num: "02",
          title: "Надёжность экспорта",
          text: "Каждая поставка обеспечена плановым календарём сбора урожая, дисциплиной контрактных производителей и сквозной прослеживаемой логистикой. Для нас своевременная доставка — не цель, а зафиксированный стандарт.",
        },
        {
          num: "03",
          title: "Бескомпромиссная политика качества",
          text: "Каждая партия продукции — от поля до контейнера — проходит аудит по требованиям GlobalGAP, ISO 22000 и BRCGS и подтверждается аккредитованными лабораторными анализами. Качество для нас — не лозунг, а измеряемый процесс.",
        },
      ],
      captionA: "Высокотехнологичное тепличное производство — Анталья",
      captionB: "Контейнерный терминал — Мерсин",
    },
    services: {
      overline: "Деятельность",
      title: "Полная экспортная архитектура — от поля до порта",
      sub: "Четыре ключевых направления объединяют каждый этап сельскохозяйственного производства под одной крышей.",
      items: [
        {
          tag: "Global Export",
          title: "Международный экспорт агропродукции",
          desc: "От цитрусовых до свежих овощей и фруктов, от зерна до бобовых — мы осуществляем контрактные, регулярные и полностью прослеживаемые экспортные операции более чем в 40 стран.",
        },
        {
          tag: "Precision Farming",
          title: "Современные агротехнологии и производство",
          desc: "Высокотехнологичные стеклянные теплицы, датчики точного земледелия и телеметрия орошения повышают урожайность — с каждого гектара мы получаем продукцию экспортного качества.",
        },
        {
          tag: "Cold Chain",
          title: "Управление цепочкой поставок и логистикой",
          desc: "Непрерывная холодовая цепь от момента сбора урожая до порта назначения — мультимодальные транспортные решения, объединяющие морской, автомобильный и воздушный транспорт.",
        },
        {
          tag: "GlobalGAP · ISO 22000",
          title: "Контроль качества и сертификация",
          desc: "Аккредитованные лабораторные анализы, тесты на остаточные вещества и международные аудиторские процедуры подтверждают полное соответствие каждой поставки стандартам целевого рынка.",
        },
      ],
    },
    stats: {
      overline: "Почему Markagro?",
      title: "Глобальное доверие в цифрах",
      sub: "Наши экспортные показатели говорят сами за себя — через растущие мощности и независимо аудируемые процессы.",
      items: [
        { value: 40, pre: { tr: "", en: "" }, suf: { tr: "+", en: "+" }, label: "Стран экспорта", desc: "Активная дистрибуция в Европе, Персидском заливе, Азии и Африке" },
        { value: 10000, pre: { tr: "", en: "" }, suf: { tr: "+", en: "+" }, label: "Тонн годового объёма", desc: "Годовая экспортная мощность, обеспеченная контрактным производством" },
        { value: 100, pre: { tr: "%", en: "" }, suf: { tr: "", en: "%" }, label: "Устойчивое производство", desc: "Прослеживаемый, сертифицированный и экологичный стандарт производства" },
        { value: 24, pre: { tr: "", en: "" }, suf: { tr: "/7", en: "/7" }, label: "Мониторинг холодовой цепи", desc: "Непрерывный контроль температуры и геолокации на базе телеметрии" },
      ],
    },
    sustainability: {
      overline: "Устойчивое развитие",
      title: "Мы растём вместе с природой.",
      text: "Для сокращения углеродного следа мы используем теплицы на возобновляемой энергии, телеметрию капельного орошения с экономией воды до 60% и перерабатываемую упаковку. Наша цель к 2030 году ясна и измерима: цепочка поставок с нулевым отходом.",
      goal: "Обязательство к 2030 году",
      goalText: "Цепочка поставок с нулевым отходом и производственные мощности, работающие на 100% возобновляемой энергии.",
      badges: ["Возобновляемая энергия", "Экономия воды 60%", "Перерабатываемая упаковка", "Использование биоудобрений"],
    },
    contact: {
      overline: "Контакты",
      title: "Давайте вместе спланируем вашу следующую поставку.",
      sub: "Заполните форму для экспортных запросов — наша торговая команда свяжется с вами в течение 24 часов.",
      form: {
        name: "Имя и фамилия",
        email: "Корпоративная почта",
        country: "Страна / город",
        service: "Интересующий продукт / услуга",
        message: "Ваше сообщение",
        submit: "Отправить запрос",
      },
      info: {
        hqTitle: "Глобальная штаб-квартира",
        hq: "Свободная зона Мерсин, Средиземноморский экспортный коридор, 33110 Мерсин / Турция",
        officeTitle: "Производственный и контактный офис",
        office: "Организованная сельскохозяйственная зона Антальи, Анталья / Турция",
        phoneTitle: "Телефон",
        phone: "+90 242 502 40 40",
        emailTitle: "Эл. почта",
        email: "info@markagroglobal.com",
      },
      newsletter: {
        title: "Агробюллетень",
        sub: "Сезонный календарь продукции и экспортные возможности — прямо в вашу почту.",
        placeholder: "Ваш адрес электронной почты",
        button: "Подписаться",
      },
      footerTagline: "С поля — в мир, с сертифицированным качеством.",
      footerCols: [
        { title: "Компания", links: ["О компании", "Политика качества", "Сертификаты", "Карьера"] },
        { title: "Деятельность", links: ["Агроэкспорт", "Современное производство", "Логистика", "Сертификация"] },
        { title: "Правовая информация", links: ["Политика конфиденциальности", "Политика cookies", "Условия использования"] },
      ],
      certs: "GLOBALG.A.P. · ISO 22000 · BRCGS · SEDEX",
      rights: "© 2026 Markagro Global. Все права защищены.",
    },
    quote: {
      title: "Запросить цену",
      sub: "Расскажите о вашей задаче — мы подготовим индивидуальное экспортное предложение.",
      name: "Имя и фамилия",
      email: "Корпоративная почта",
      product: "Группа товаров",
      products: ["Цитрусовые", "Свежие овощи и фрукты", "Зерно и бобовые", "Тепличная продукция"],
      volume: "Ориентировочный объём",
      unit: "т",
      submit: "Отправить запрос на цену",
    },
    toasts: {
      contact: "Ваш запрос получен — наша торговая команда свяжется с вами в ближайшее время.",
      newsletter: "Вы подписались на агробюллетень — добро пожаловать.",
      quote: "Ваш запрос на цену получен — мы ответим в течение 24 часов.",
      error: "Что-то пошло не так — повторите попытку позже.",
    },
  },
};

export const productsCopy = {
  tr: {
    navLabel: "Ürünler",
    overline: "Ürün Kataloğu",
    title: "Sezonluk ihracat takvimi",
    sub: "Hangi ürünün hangi ayda hasat edildiğini görün; tedarik planınızı sezona göre optimize edin.",
    legendSeason: "Sezon",
    legendPeak: "Hasat zirvesi",
    legendNow: "Bu ay",
    inSeason: "Şu An Sezonunda",
    rangeNote: "Kataloğumuz bunlarla sınırlı değil — sezonuna göre çok daha geniş bir ürün yelpazesi ihraç ediyoruz.",
    rangeCta: "Detaylı ürün yelpazesi için iletişime geçin",
    months: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
    items: [
      { name: "Washington Navel Portakal", origin: "Akdeniz Havzası", desc: "Yüksek şeker-asit dengesi, uzun raf ömrü ve ihracat standardı kalibrasyon." },
      { name: "Interdonato Limon", origin: "Akdeniz Kıyı Şeridi", desc: "Erkenci hasat, ince kabuk, yoğun aroma — Avrupa pazarlarının favorisi." },
      { name: "Satsuma Mandalina", origin: "Ege & Akdeniz", desc: "Kolay soyulan kabuk, çekirdeksiz yapı — premium perakende raflarına uygun." },
      { name: "Hicaz Nar", origin: "Ege Havzası", desc: "Parlak tane rengi, yüksek antioksidan, uzun mesafe taşıma dayanıklılığı." },
      { name: "Sera Domatesi", origin: "Antalya Sera Bölgesi", desc: "Yıl boyu kesintisiz üretim; yüksek teknolojili cam seralarda kontrollü yetiştiricilik." },
      { name: "Sofralık Üzüm", origin: "Ege Bağları", desc: "İri tane, gevrek doku — soğuk zincirle tazeliğini koruyan hasat." },
    ],
  },
  en: {
    navLabel: "Products",
    overline: "Product Catalog",
    title: "Seasonal export calendar",
    sub: "See which crop is harvested in which month — and optimize your sourcing plan around the season.",
    legendSeason: "Season",
    legendPeak: "Harvest peak",
    legendNow: "This month",
    inSeason: "In Season Now",
    rangeNote: "Our catalog goes far beyond these highlights — we export a much wider range of produce depending on the season.",
    rangeCta: "Contact us for the full product range",
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    items: [
      { name: "Washington Navel Orange", origin: "Mediterranean Basin", desc: "High sugar-acid balance, long shelf life and export-grade calibration." },
      { name: "Interdonato Lemon", origin: "Mediterranean Coast", desc: "Early harvest, thin peel, intense aroma — a favourite of European markets." },
      { name: "Satsuma Mandarin", origin: "Aegean & Mediterranean", desc: "Easy-peel skin, seedless flesh — perfect for premium retail shelves." },
      { name: "Hicaz Pomegranate", origin: "Aegean Basin", desc: "Bright aril color, high antioxidants, long-haul shipping durability." },
      { name: "Greenhouse Tomato", origin: "Antalya Greenhouse Region", desc: "Uninterrupted year-round production in high-tech glass greenhouses." },
      { name: "Table Grape", origin: "Aegean Vineyards", desc: "Large berries, crisp texture — harvest freshness preserved by cold chain." },
    ],
  },
  ru: {
    navLabel: "Продукция",
    overline: "Каталог продукции",
    title: "Сезонный экспортный календарь",
    sub: "Смотрите, какая продукция собирается в каждом месяце, и планируйте закупки с учётом сезона.",
    legendSeason: "Сезон",
    legendPeak: "Пик урожая",
    legendNow: "Текущий месяц",
    inSeason: "Сейчас в сезоне",
    rangeNote: "Наш ассортимент не ограничивается этими позициями — в зависимости от сезона мы экспортируем гораздо более широкую линейку продукции.",
    rangeCta: "Свяжитесь с нами для полного ассортимента",
    months: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
    items: [
      { name: "Апельсин Вашингтон Навел", origin: "Средиземноморский бассейн", desc: "Высокий баланс сахара и кислотности, длительный срок хранения, экспортная калибровка." },
      { name: "Лимон Интердонато", origin: "Средиземноморское побережье", desc: "Ранний урожай, тонкая кожура, насыщенный аромат — фаворит европейских рынков." },
      { name: "Мандарин Сацума", origin: "Эгейский регион и Средиземноморье", desc: "Легко очищается, без косточек — идеален для премиальных полок." },
      { name: "Гранат Хиджаз", origin: "Эгейский бассейн", desc: "Яркие зёрна, высокое содержание антиоксидантов, устойчивость к дальним перевозкам." },
      { name: "Тепличный томат", origin: "Тепличный регион Антальи", desc: "Круглогодичное непрерывное производство в высокотехнологичных стеклянных теплицах." },
      { name: "Столовый виноград", origin: "Эгейские виноградники", desc: "Крупные ягоды, хрустящая текстура — свежесть сохраняется холодовой цепью." },
    ],
  },
};

export const productCopy = {
  tr: {
    overline: "İmza Ürün",
    caption: "Washington Navel Portakal — Akdeniz Havzası",
    features: [
      { title: "Sürdürülebilir Üretim", sub: "Her damla su telemetriyle ölçülür; her dönüm izlenebilir." },
      { title: "Kusursuz Kalite", sub: "Akredite laboratuvar analizleriyle belgelenen ihracat standardı." },
      { title: "Global İhracat", sub: "Kesintisiz soğuk zincirle 40'tan fazla ülkeye." },
    ],
  },
  en: {
    overline: "Signature Produce",
    caption: "Washington Navel Orange — Mediterranean Basin",
    features: [
      { title: "Sustainable Production", sub: "Every drop of water measured by telemetry; every hectare traceable." },
      { title: "Flawless Quality", sub: "Export standard documented by accredited laboratory analyses." },
      { title: "Global Export", sub: "To more than 40 countries via an unbroken cold chain." },
    ],
  },
  ru: {
    overline: "Фирменная продукция",
    caption: "Апельсин Вашингтон Навел — Средиземноморский бассейн",
    features: [
      { title: "Устойчивое производство", sub: "Каждая капля воды измеряется телеметрией; каждый гектар прослеживаем." },
      { title: "Безупречное качество", sub: "Экспортный стандарт, подтверждённый аккредитованными лабораториями." },
      { title: "Глобальный экспорт", sub: "Более чем в 40 стран по непрерывной холодовой цепи." },
    ],
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("tr");
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
